function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

var _timeElapsedSince = /*#__PURE__*/_classPrivateFieldLooseKey("timeElapsedSince");

var FilePresenter = /*#__PURE__*/function () {
  function FilePresenter() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, FilePresenter);

    Object.defineProperty(this, _timeElapsedSince, {
      value: _timeElapsedSince2
    });
    this.update(data);
  }

  _createClass(FilePresenter, [{
    key: "update",
    value: function update(_ref) {
      var uploadAt = _ref.uploadAt,
          reason = _ref.reason,
          isSuccessful = _ref.isSuccessful,
          _ref$uppyFile = _ref.uppyFile,
          newUppyFile = _ref$uppyFile === void 0 ? {} : _ref$uppyFile,
          _ref$meta = _ref.meta,
          newMeta = _ref$meta === void 0 ? {} : _ref$meta;
      this.uploadAt = uploadAt || this.uploadAt;
      this.reason = reason || this.reason;
      this.isSuccessful = isSuccessful !== null && isSuccessful !== void 0 ? isSuccessful : this.isSuccessful; // null-coalescing because value type is boolean

      this.uppyFile = _objectSpread(_objectSpread({}, this.uppyFile || {}), newUppyFile);
      this.meta = _objectSpread(_objectSpread({}, this.meta || {}), newMeta);
      return this;
    }
  }, {
    key: "id",
    value: function id() {
      var _this$uppyFile$id;

      return (_this$uppyFile$id = this.uppyFile.id) !== null && _this$uppyFile$id !== void 0 ? _this$uppyFile$id : null;
    }
  }, {
    key: "url",
    value: function url() {
      var _this$uppyFile$upload;

      return (_this$uppyFile$upload = this.uppyFile.uploadURL) !== null && _this$uppyFile$upload !== void 0 ? _this$uppyFile$upload : null;
    }
  }, {
    key: "error",
    value: function error() {
      var _this$uppyFile$error;

      return (_this$uppyFile$error = this.uppyFile.error) !== null && _this$uppyFile$error !== void 0 ? _this$uppyFile$error : null;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var _this$meta$ConfirmedB, _this$meta$ConfirmedK, _ref2, _this$uppyFile$extens, _this$uppyFile$displa, _this$uppyFile$size, _this$uppyFile$source, _this$uppyFile$upload2, _this$reason, _this$isSuccessful, _this$uploadAt$toUTCS, _this$uploadAt;

      return {
        error: this.error(),
        // `meta` data
        bucket: (_this$meta$ConfirmedB = this.meta.ConfirmedBucket) !== null && _this$meta$ConfirmedB !== void 0 ? _this$meta$ConfirmedB : null,
        key: (_this$meta$ConfirmedK = this.meta.ConfirmedKey) !== null && _this$meta$ConfirmedK !== void 0 ? _this$meta$ConfirmedK : null,
        // shared `meta` & `uppyFile` data
        mimetype: (_ref2 = this.meta.filetype || this.uppyFile.type) !== null && _ref2 !== void 0 ? _ref2 : null,
        // `uppyFile` data
        extension: (_this$uppyFile$extens = this.uppyFile.extension) !== null && _this$uppyFile$extens !== void 0 ? _this$uppyFile$extens : null,
        filename: (_this$uppyFile$displa = this.uppyFile.displayName) !== null && _this$uppyFile$displa !== void 0 ? _this$uppyFile$displa : null,
        size: (_this$uppyFile$size = this.uppyFile.size) !== null && _this$uppyFile$size !== void 0 ? _this$uppyFile$size : null,
        source: (_this$uppyFile$source = this.uppyFile.source) !== null && _this$uppyFile$source !== void 0 ? _this$uppyFile$source : null,
        uploadUrl: (_this$uppyFile$upload2 = this.uppyFile.uploadURL) !== null && _this$uppyFile$upload2 !== void 0 ? _this$uppyFile$upload2 : null,
        reason: (_this$reason = this.reason) !== null && _this$reason !== void 0 ? _this$reason : null,
        isSuccessful: (_this$isSuccessful = this.isSuccessful) !== null && _this$isSuccessful !== void 0 ? _this$isSuccessful : null,
        isFailed: this.isSuccessful === false || this.error() ? true : null,
        uploadAt: (_this$uploadAt$toUTCS = (_this$uploadAt = this.uploadAt) === null || _this$uploadAt === void 0 ? void 0 : _this$uploadAt.toUTCString()) !== null && _this$uploadAt$toUTCS !== void 0 ? _this$uploadAt$toUTCS : null,
        uploadAtTimeElapsed: _classPrivateFieldLooseBase(this, _timeElapsedSince)[_timeElapsedSince](this.uploadAt)
      };
    }
  }], [{
    key: "updateEachByIdAndRecache",
    value: // updateEachByIdAndRecache
    // Matches two arrays of FilePresenters by id and mutates each
    //  - `cachedFPList` will each call `update()` with the matching target FP
    //  - `targetFPList` will each be _replaced_ with the matching cached FP after the cached FP has been updated
    function updateEachByIdAndRecache() {
      var targetFPList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var cachedFPList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (!cachedFPList.length) return;
      targetFPList.forEach(function (targetFPInstance) {
        var cachedFPInstance = cachedFPList.find(function (_cached) {
          return _cached.id() === targetFPInstance.id();
        });
        cachedFPInstance.update(targetFPInstance);
        Object.assign(targetFPInstance, cachedFPInstance);
      });
    }
  }, {
    key: "errorsFrom",
    value: function errorsFrom() {
      var instances = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return instances.map(function (_fp) {
        return _fp.error();
      }).filter(Boolean);
    }
  }]);

  return FilePresenter;
}();

function _timeElapsedSince2(date) {
  if (!(date instanceof Date)) return null;
  return new Date().getTime() - date.getTime();
}

export default FilePresenter;